<!-- 产品商城 -->
<template>
    <div class="product-store-container" ref="activity_scroll" @scroll="activityScroll">
        <!-- 顶部搜索组件 -->
        <roof-search v-if="showNav" @secondCategoryChange="secondCategoryChange"></roof-search>
        <!-- 商城 -->
        <product-content showMoreBtn :productList="productList" v-if="false"></product-content>
        <!-- 分类导航 -->
        <classify-nav></classify-nav>
    </div>
</template>

<script>
import { getProductList } from '@/api/product'
import roofSearch from '@/components/roof-search'
import productContent from './components/product-content'
import classifyNav from './components/classify-nav'
import { wxShare } from '@/libs/wxjssdk'

export default {
    components: {
        roofSearch,
        productContent,
        classifyNav
    },
    beforeRouteLeave (to, from, next) {
        // console.log('路由离开', this.scrollTop)
        this.$store.commit('setScrollTop', this.scrollTop)
        next()
    },
    data () {
        return {
            showNav: true,
            productList: [],
            scrollTop: 0,
            page: 1,
            last_page: ''
        }
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    activated () {
        this.showNav = true
        this.sharePage()
        this.$nextTick(() => {
            this.$refs.activity_scroll.scrollTop = this.$store.state.scrollTop
        })
    },
    deactivated () {
        this.showNav = false
    },
    created () {
        var query = this.$route.query
        if (query.detail_id) {
            this.$router.push(
                {
                    name: 'productDetails',
                    query: {
                        id: query.detail_id,
                        isShowNav: true
                    }
                }
            )
        }
        // if (query.testing) {
        //   this.$store.commit('setTesting', '1')
        // }
        // console.log(123123123, query.detail_id)
        this.getProductListPort()
    },
    mounted () {
        this.sharePage()
    },
    methods: {
        sharePage () {
            const params = {
                title: 'Eppendorf 产品商城', // 分享标题
                desc: 'Eppendorf 产品商城', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        // 单击了分类
        secondCategoryChange () {
            this.$router.push('secondProduct')
        },
        // 上拉触底
        activityScroll () {
        // var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
        // var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
        // var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
        // var inadvance = 150 // 距离底部距离
        // this.scrollTop = scrollTop
        // if (scrollHeight - scrollTop - inadvance <= clientHeight) {
        //   if (this.page < this.last_page) {
        //     this.page++
        //     this.getProductListPort()
        //   }
        // }
        },
        /** 网络请求 **/
        // 根据一级类别获取产品数据
        getProductListPort () {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            var params = {
                separate_category: 0,
                page: this.page
            }
            getProductList(params).then(res => {
                this.$toast.clear()
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    var productList = data.data
                    // console.log(1236, productList)
                    // 加个data_length字段,处理是否出现没有数据的图片
                    // productList.map((val) => {
                    //   if (val.data_length !== 0) {
                    //     val.data_length = false
                    //   } else {
                    //     val.data_length = true
                    //   }
                    // })
                    this.productList.push(...productList)
                    // console.log(11222333, data)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .product-store-container {
        background: #eeebf4;
        /*display: flex;*/
        /*flex-direction: column;*/
        height: 100vh;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }
</style>
